module.exports = __webpack_public_path__ + "img/scan-barcode.b5d2fb8a.svg";